import { render, staticRenderFns } from "./AssetHeader.vue?vue&type=template&id=17438597&"
import script from "./AssetHeader.vue?vue&type=script&lang=js&"
export * from "./AssetHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports